import script from "./wTransfer.vue?vue&type=script&setup=true&lang=ts"
export * from "./wTransfer.vue?vue&type=script&setup=true&lang=ts"

import "./wTransfer.vue?vue&type=style&index=0&id=10e07ae7&lang=scss&scoped=true"

import exportComponent from "D:\\code\\idea2023\\dmMes\\h5_standard\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-10e07ae7"]])

export default __exports__